<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix no_print">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.redeem_order_sn" placeholder="赎货单号"></el-input>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('loadmissuing')">
                <el-option v-for="(list,index) in selectMap.loadmissuing" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.status" placeholder="赎货状态" @visible-change="getSelectList('redeemstatus')">
                <el-option v-for="(list,index) in selectMap.redeemstatus" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.sales_status" placeholder="订单状态" @visible-change="getSelectList('redeemsales')">
                <el-option v-for="(list,index) in selectMap.redeemsales" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.order_sn" placeholder="关联销售单"></el-input>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
             <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnBox">
            <div class="payBtnDiv" >
                <el-button  type="info" class="publicBtn" @click="batchShowPayMoney(1)">预赎付款</el-button>
            </div>
            <div class="balanceDiv">
                <el-radio-group v-model="currentPayRadio" class="banCheckboxGroup">
                    <!-- el-radio -->
                    <el-radio class="balanceItem" size="medium"
                                    v-for="(it,i) in  balance" :key="'ck_'+i" :label="it">
                        <i class="iconfont icon-hetong-3 balanceIcon"></i>
                        <!-- <img class="balanceIcon" src="/icon/finance.png"> -->
                        <span style="text-decoration: underline;position: relative;top: 5px;" @click.prevent="toShortDetail(it)">{{it.short_name}}（赎货余额）</span>
                        <span style="position: relative;top: 5px;">：</span>
                        <!-- ￥ -->
                        <span class="underCanClick" style="text-decoration: underline;position: relative;top: 5px;" @click.prevent="showBalanceDialog(it)">{{it.balance}}m³</span>
                    </el-radio>
                </el-radio-group>
            </div>
        </div>
        <div class="tableBox no_print">
            <tabletem :isShowIndex="true" :isSetCol="true" scene="redeem.order.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalNumber">赎货单:{{tot.redeem_count}}单</div>
            <div class="totalNumber">未付金额:{{tot.unpay_amount}}</div>
            <!--<div class="totalNumber">人民币总金额:{{totalObj.rmb_amount}}</div>
            <div class="totalNumber">已付金额:{{totalObj.payment_amount}}</div>
            <div class="totalNumber">未付金额:{{totalObj.un_payment_amount}}</div> -->
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 新增付款单 dialog START -->
        <el-dialog v-dialog-drag :title="addType==1?'预赎付款':'赎货付款'" :visible.sync="payMoneyDialog" class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="融资合同：" required>
                        <el-select v-model="add_params.purchase_id" placeholder=""  :disabled="addType==1?false:true" @change="changePurchase_id(add_params.purchase_id)" @visible-change="getSelectList('pledgePurchase')">
                            <el-option v-for="item in selectMap.pledgePurchase" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="融资提单：" required>
                        <el-select v-model="add_params.finance_order_id" placeholder="" :disabled="addType==1?false:true" @visible-change="getPledgeOrderList(add_params.purchase_id)">
                            <el-option v-for="item in pledgeOrderList" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易日期：" required>
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                   <el-form-item label="我方账户：" required>
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款方：" prop="receipt_name" required>
                        <el-input v-model="add_params.receipt_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="流水类型：" prop="bill_type_text" required>
                        <el-input v-model="add_params.bill_type_text" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易方式：" required>
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="科目名称：" prop="course_name" required>
                        <el-input  v-model="add_params.course_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="付款金额：" required>
                        <el-input v-model="add_params.pay_amount" @input.native="changeRate($event,add_params.amount)"  placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                    <!-- <el-form-item prop="pay_file" style="height: 35px" >
                                     <span slot="label"><span>付款凭证：</span>
                        <ym-upload ref="payUp" :init-list="fileListShow" :disabled="false" :form-param.sync="add_params.pay_file"></ym-upload>
                    </el-form-item> -->
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="payMoneyDialog=!payMoneyDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn"  @click="addOrderSheetBack(type)">付款</el-button>
            </div>
        </el-dialog>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'销售赎货单(单号：'+form_params.redeem_order_sn+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="开证公司：" prop="customer_id">
                            <el-input v-model="form_params.issuing" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="赎货日期：" prop="salesman_id">
                            <el-date-picker v-model="form_params.redeem_date" type="date" :readonly="true" placeholder="" size="mini" disabled></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="融资合同号：" prop="sales_time">
                            <el-input v-model="form_params.contract_no" disabled></el-input>
                        </el-form-item>
                        <!-- <el-form-item  label="赎货人：" prop="sales_time">
                            <el-input v-model="form_params.redeemer_name" disabled></el-input>
                        </el-form-item> -->
                    </div>
                    <div class="globalSee" style="right: 30px;top: 4px;" @click="linkSeeReview"></div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <!-- <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column> -->
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="融资单号" width="135" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.finance_order_sn }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.brand}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.grade}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.spec}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="original_cube" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.original_cube}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="赎货单价" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.redeem_price}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="赎货金额" prop="redeem_amount" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.redeem_amount}}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                </div>
                <div class="totalCal">
                    <div class="totalName">合计：</div>
                    <div class="totalNumber">可发方数:{{form_params.property_cube}}m³</div>  
                    <div class="totalNumber">赎货单方数:{{form_params.redeem_cube}}m³</div>      
                    <div class="totalNumber">应赎方数:{{form_params.pay_redeem_cube}}m³</div>
                    <div class="totalNumber" v-if="form_params.pay_redeem_amount>0">应付金额: <span  style="color:red">{{form_params.pay_redeem_amount}}</span></div>  
                    <div class="totalNumber" v-if="form_params.real_pay_amount>0">实付金额:{{form_params.real_pay_amount}}</div>
                    <div class="totalNumber">应赎金额:{{form_params.real_redeem_amount}}</div>      
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">销售人：{{form_params.salesman_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div>-->
                </div>
                <div>

                </div>
                <div class="editBtnList clearfix">
                    <!-- <div class="balanceDiv">
                        <img class="balanceIcon" src="/icon/finance.png" style="position: relative;top: 5px;margin-right: 10px;">
                        <span style="font-weight: 700;">赎货余额({{issuing_balance.short_name}})：{{issuing_balance.balance}}</span>
                    </div> -->
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="print(0)">打印</el-button>
                        <el-button class="funcPublicBtn" @click="exportExcel">导出</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="openaddDialogVisibleBack(2)">付款</el-button> 
                    </div>
                </div>
                
            </div>
        </el-dialog>
        <!-- dialog END -->
         <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="redeem.order.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="redeem.sales.column" :filterDialogVisible="filterDialogVisibleB" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleB = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 货权明细 START -->
        <el-dialog v-dialog-drag :visible.sync="cargodetailsDialog" class="eldialog specTable" width="500px" :modal="false" title="查看货权" custom-class="full_dialog">
             <!-- :summary-method="getTableSummaries"  show-summary  -->
            <div class="search_box search_box_c clearfix no_print">
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="cargo.issuing_id" placeholder="开证公司" @visible-change="getSelectList('loadmissuing')">
                    <el-option v-for="(list,index) in selectMap.loadmissuing" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="cargo.order_sn" placeholder="融资提单号"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reseCargot">重置</div>
                    <el-button  class="publicBtn" @click="getCargoDetail()">查询</el-button>
                </div>
            </div>
            <el-table :data="cargoDetail" border stripe highlight-current-row  size="mini"  style="min-height:250px;max-height:400px;margin-top: 5px;">
                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="开证公司" prop="issuing" show-overflow-tooltip></el-table-column>
                <el-table-column label="融资提单" prop="order_sn" show-overflow-tooltip></el-table-column>
                <el-table-column label="监管方数" prop="supervise_cube" show-overflow-tooltip></el-table-column>
                <el-table-column label="可发方数" prop="property_cube" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;">
                    <!-- <span style="padding-left: 25px;">合计：{{cubeTotal.cube}}m³</span>
                    <span style="padding-left: 25px;">外币金额：{{cubeTotal.foreign_amount}}</span>   -->
                </div>
            </div>
       </el-dialog>
        <!-- 货权明细 END -->

    </div>
</template>
<script>
    import bus from "../../../../eventBus";
    import tabletem from '../../../../components/table.vue';
    import pagination from '../../../../components/pagination.vue';

    const initPayForm={
        issuing_id:"",
        trading_time:"",
        pay_amount:"",
        account_id:"",
        payment_type_id:"",
        remark:"",
        pay_file: [],
        course_name:"赎货付款",
        bill_type_text:"支出",
    };
    export default {
        data(){
            return {
                module: localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                },
                last_page: 10,
                total:0,
                tot:{},
                fields:"",
                filter:"",
                filters: [],
                filterDialogVisible:false,
                filterDialogVisibleB:false,
                isGlobal:false,
                tableLoading:false,
                selectRow:[],
                tableCol:[
                    {colName:"赎货单号",colKey:"redeem_order_sn",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,},
                    {colName:"赎货日期",colKey:"redeem_date",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎货状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"融资合同号",colKey:"contract_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资提单号",colKey:"finance_order_sn",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"应赎方数",colKey:"redeem_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"应付金额",colKey:"unpay_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"实付金额",colKey:"real_pay_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"赎货付款人",colKey:"payer_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款记录",colKey:"redeem_order_id",colWidth:85,isCanClick:true,isColor:true,isHideShowClickImg:true,},
                    {colName:"备注",colKey:"remark",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                list:[],
                selectMap:{
                    loadmissuing:[],
                    redeemstatus:[],
                    redeemsales:[],
                    paymentType:[],
                    account:[],
                    pledgePurchase:[]
                },
                selectMapF:{},
                balance: [],//余额
                currentPayRadio:'',
                payMoneyDialog:false,
                add_params:this.$cloneJson(initPayForm),
                fileListShow:[],
                trading_time:new Date(),
                dialogVisible:false,
                form_params:{},
                issuing_balance:{},
                listDetail:[],
                type:0,
                addType:0,
                pledgeOrderList:[],
                cargodetailsDialog:false,
                cargoDetail:[],
                cargo:{
                    order_sn:'',
                    issuing_id:''
                }
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.getSelectList('loadmissuing');
            this.getSelectList('account')
            this.getSelectList('paymentType');
            this.getSelectList('pledgePurchase');
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            payMoneyTop(){},
            changePurchase_id(){
                this.pledgeOrderList =[];
                this.add_params.finance_order_id=''
            },
            getPledgeOrderList(purchase_id){
                this.postFunc('/erp/pledge.order.option',{purchase_id:purchase_id},res=>{
                    this.pledgeOrderList = res.data.data
                })
            },
            getList(){
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/redeem.order.list",this.params,res=>{
                    this.balance = res.data.data.issuing_balance;
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.tot= res.data.data.total;
                    this.list=res.data.data.data.data;
                    let obj ={
                        sales_count:res.data.data.sales_count,
                        advance_count:res.data.data.advance_count
                    }
                    this.$emit('child-num',obj)
                    this.list.forEach((item,index)=>{
                        item.baseColor = "";
                        this.list[index].redeem_date = this.formatTime(item.redeem_date+"000")
                        if(item.status_text=='待付款'){
                            item.baseColor='red';
                        }
                        item.redeem_order_id = '查看详情'
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        item.status_textColor = item.status_text == 1 ? "#FF4C52":" ";
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            toggleSelection(row) {
                if(row.isSelect==1){
                    this.$refs.outBoundDetailTable.toggleRowSelection(row);
                }else{
                    return false;
                }
            },
            getRow(row){
                this.selectRow=row;
            },
            changeRate(e,input){
                e.target.value=(e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})","g"))[0]) || null
                let inputs=e.target.value;
                this.add_params.pay_amount=inputs;
            },
            batchShowPayMoney(type) {
                this.type = type;
                this.addType = type;
                let ts = this.selectRow;//表格的选中项
                let cr = this.currentPayRadio;
                if (ts.length > 0 && !cr) {
                    this.tip("表格内数据付款请进入详情页面操作","warning");
                    return;
                }
                if (!cr) {
                    this.tip("必须选择右侧一条付款项", "warning");
                    return;
                }
                this.add_params.issuing_id = cr.id;
                this.add_params.receipt_name = cr.name;
                this.payMoneyDialog = true;
            },
            //付款确定
            addOrderSheetBack(ty){
                this.add_params.trading_time = this.formatTimeZero(this.trading_time);
                this.add_params.pay_amount = Number(this.add_params.pay_amount);
                this.add_params.redeem_type = 1;
                if(ty==1){
                    this.postFuncLoading('/erp/redeem.payment',this.add_params,res=>{
                        this.tip('付款成功',"success");
                        this.payMoneyDialog = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.add_params.redeem_order_sn = this.form_params.order_sn;
                    this.add_params.redeem_order_id = this.form_params.id;
                    // this.add_params.issuing_id = this.form_params.issuing_balance.id;
                    this.postFuncLoading('/erp/redeem.payment',this.add_params,res=>{
                        this.tip('付款成功',"success");
                        this.payMoneyDialog = false;
                        this.dialogVisible = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            openaddDialogVisibleBack(type){
                this.type = type;
                this.addType = type;
                this.payMoneyDialog = true;
                this.add_params.receipt_name = this.form_params.issuing;
                this.add_params.purchase_id = this.form_params.purchase_id;
                this.add_params.finance_order_id = this.form_params.finance_order_id;
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name =='redeem_order_sn'){
                    this.scene = 'redeem.sales.column';
                    this.isGlobal = true;
                    this.getBillColumn();
                    this.dialogVisible = true;
                    this.postFunc('/erp/redeem.order.info',{id:obj.id},res=>{
                        this.form_params = res.data.data;
                        this.getPledgeOrderList(this.form_params.purchase_id);
                        this.add_params.pay_amount = this.form_params.unpay_amount;
                        this.form_params.redeem_date = this.formatTime(this.form_params.redeem_date+"000");
                        this.issuing_balance = this.form_params.issuing_balance;
                        this.listDetail = this.form_params.details;
                    })
                }else if(obj.name =='redeem_order_id'){
                    sessionStorage.removeItem("STORE_ISSUING_ID")
                    sessionStorage.setItem("STORE_ISSUING_ID",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '赎货流水'+obj.id,
                        label: '赎货流水',
                        content: 'bankRedeemFlow'
                    });
                }
            },
            //查看货权
            showBalanceDialog(item){
                this.postFunc('/erp/pledge.goods.power',{issuing_id:[item.id]},res=>{
                    this.cargoDetail = res.data.data.list
                })
                this.cargo.issuing_id = [item.id];
                this.cargodetailsDialog = !this.cargodetailsDialog;
                //跳转到新页面
                // sessionStorage.removeItem("STORE_ISSUING_ID")
                // sessionStorage.setItem("STORE_ISSUING_ID",item.id)
                // this.$root.$children[0].$children[0].addTab({
                //     name: '赎货余额流水'+item.id,
                //     label: '赎货余额流水',
                //     content: 'bankRedeemFlow'
                // });
            },
            getCargoDetail(){
                 this.postFunc('/erp/pledge.goods.power',this.cargo,res=>{
                    this.cargoDetail = res.data.data.list
                })
            },
            reseCargot(){
                this.cargo=this.resetSearch(this.cargo);
                this.getCargoDetail();
            },
            //跳转赎货详情
            toShortDetail(item){
                sessionStorage.removeItem("STORE_ISSUING_ID")
                sessionStorage.setItem("STORE_ISSUING_ID",item.id)
                this.$root.$children[0].$children[0].removeNameTab('赎货详情'+item.id,
                {
                    name: '赎货详情'+item.id,
                    label: '赎货详情',
                    content: 'foreclosureDetail'
                });
            },
            print(type){
                let url = "/redemptionOrderPrint?id=" + this.form_params.id ;
                window.open(url);
            },
            // 查看赎货单单预览
            linkSeeReview() {
               
                sessionStorage.removeItem("DEMU_ERP_ORDERSEE_ID");
                sessionStorage.setItem("DEMU_ERP_ORDERSEE_ID", this.form_params.id);
                this.$root.$children[0].$children[0].addTab({
                    name: '赎货单预览' + this.form_params.id,
                    label: '赎货单预览',
                    content: 'bankOrderSee'
                });
                
            },
            excelExport(){
                this.$exportExecl("/erp/redeem.order.export","销售赎货",this.params)
            },
            exportExcel(){
                this.$exportExecl("/erp/redeem.order.info.export","销售赎货单",{id:this.form_params.id})
            },
            //合计
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube:4,
                    redeem_amount:2,
                    interest:2
                },total=>{
                });
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "payMoneyDialog":function(val){
                if (!val) {
                    this.add_params = this.$cloneJson(initPayForm);
                    this.$refs['add_form'].resetFields();
                    this.fileListShow = [];
                }
            }
        }
    }
</script>
<style  scoped lang="scss">
.btnBox{
        display: flex;
        .payBtnDiv{
            padding: 5px 20px 10px 0;display: inline-block;border-right: 2px solid #eee;
        }
        .balanceDiv{
            display: inline-block;
            .banCheckboxGroup{
                display: flex;
                margin-left: 20px;
            }
            .balanceItem{
                margin-left: 20px;
                line-height: 24px;
                font-weight: 600;
                font-size: 14px;
                margin-top: 7px;
                .balanceIcon{
                    position: relative;
                    top: 5px;
                    margin-right: 1px;
                    font-size: 24px;
                    color: darkorange;
                }
                .balanceImg{
                    width: 20px;
                    height: 19px;
                    position: relative;
                    top: 5px;
                    margin-right: 5px;
                }
                /*重写radio样式*/
                /deep/ .el-radio__inner{
                    width: 20px;
                    height: 20px;
                    border-radius: 2px;
                    top: 2px;
                }
                /deep/ .el-radio__input.is-checked .el-radio__inner:after{
                    width: 6px;
                    height: 13px;
                    box-sizing: content-box;
                    border: 1px solid #fff;
                    border-left: 0;
                    border-top: 0;
                    left: 6px;
                    position: absolute;
                    border-radius: 2px;
                    transform-origin: center;
                    transform: rotate(45deg);
                    background: none;
                    top: 0;
                }
            }
        }
    }
     .editBtnList{padding:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .formSpan{
        display: inline-block;
        width: 190px;
        font-size: 12px;
        text-align: left;
        padding-left: 5px;
        box-sizing: border-box;
    }
    .editPerson{padding-top: 10px;}
</style>